"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const getState_1 = require("../../helpers/getState");
const entity_1 = require("../../type/entity");
const executeRollupRule_1 = require("./executeRollupRule");
function getCompletionStatusForNonLeafNode(state, user, content, allStates, resetProgressFlag = false) {
    const childrenStates = getState_1.getChildrenStatesForContentByUserId(allStates, content, user.userId);
    const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
    const contributingChilds = content.children.filter((childContent) => !!childContent.contributeToCompleteStatus);
    if (contributingChilds.length === 0 && !resetProgressFlag) {
        return entity_1.CompletionStatus.COMPLETE;
    }
    const validChildrenCompletionStatus = contributingChilds.map((childContent) => {
        const childContentId = childContent._id;
        const childState = childrenStatesByContentId[childContentId];
        return childState.completionStatus;
    });
    const completionStatusRollupRules = content.completionStatusRollupRules;
    for (const rollupRule of completionStatusRollupRules) {
        const { requiredCondition, formula, action } = rollupRule;
        if (executeRollupRule_1.executeRollupRule(validChildrenCompletionStatus, requiredCondition, formula, state.scaledScore)) {
            return action;
        }
    }
    return entity_1.CompletionStatus.NOT_ATTEMPTED;
}
exports.getCompletionStatusForNonLeafNode = getCompletionStatusForNonLeafNode;
//# sourceMappingURL=getCompletionStatusForNonLeafNode.js.map